export const TRANSACTION_TYPES = [
  "Delivery",
  "Dine In",
  "Take Out",
  "GrabFood",
  "FoodPanda",
  "Pick Up",
  "Del Time",
  "Drive-thru",
  "Tablevibe",
  "undefined",
];

export const TRANSACTION_TYPE_MAPPING = {
  U: "Delivery",
  D: "Dine In",
  T: "Take Out",
  G: "GrabFood",
  F: "FoodPanda",
  P: "Pick Up",
  B: "Del Time",
  K: "Drive-thru",
  H: "Tablevibe",
};

export const CURRENCY_FORMATTER = new Intl.NumberFormat("en-PH", {
  style: "currency",
  currency: "PHP",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
